import { useEffect } from 'react';
import { Form } from 'antd';

import { AggregatedProductIdentity } from 'codegen';

const { useWatch, useFormInstance } = Form;

export const IdentitiesFieldsChange = () => {
  const form = useFormInstance();

  const typeFieldValue = useWatch('type', form);

  useEffect(() => {
    if (typeFieldValue === AggregatedProductIdentity.type.NAME) {
      form.resetFields(['fullMatchThreshold', 'partialMatchThreshold']);
      form.setFieldValue('partialMatchThreshold', 0.77);
      form.setFieldValue('fullMatchThreshold', 0.9);
    }

    if (typeFieldValue === AggregatedProductIdentity.type.SKU) {
      form.resetFields(['fullMatchThreshold', 'partialMatchThreshold']);
      form.setFieldValue('partialMatchThreshold', 0.8);
      form.setFieldValue('fullMatchThreshold', 1);
    }
  }, [typeFieldValue]);

  return null;
};
